import BannerPlaceholder from './BannerPlaceholder'

export default BannerPlaceholder
// eslint-disable-next-line import/export
export * from './BannerPlaceholder'
